import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import McpLogo from './icon-mcp-logo.svg';

function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <McpLogo {...validProps} />;
}
SvgComponent.iconName = 'mcpLogo';

export const McpLogoIcon = svgIconWrapper(SvgComponent);
